module.exports = __webpack_public_path__ + "img/prescription-bottle-alt.7629d31b.svg";